import { render, staticRenderFns } from "./NameSearch.vue?vue&type=template&id=74d20360&"
import script from "./NameSearch.vue?vue&type=script&lang=js&"
export * from "./NameSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports